import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo, isValidElement, cloneElement } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon/Icon.es.js';
import { SkeletonBox } from '../../SkeletonBox/SkeletonBox.es.js';
import { useStatusTrackContext } from '../StatusTrackerContext/index.es.js';

const icons = {
    'in-progress': 'EllipseSolid',
    'not-started': 'EllipseOutline',
    success: 'CheckCircleSolid',
    error: 'XCircleSolid',
    warning: 'ExclamationCircleSolid',
    loading: 'CircleSpinnerSolid'
};
const StatusTrackerStep = ({ className, children, iconStatus = 'not-started', status = 'not-started', isLastStep, ...rest })=>{
    const { loading } = useStatusTrackContext();
    const updatedChildren = useMemo(()=>{
        const elements = Array.isArray(children) ? children : [
            children
        ];
        return elements.map((element, index)=>{
            if (/*#__PURE__*/ isValidElement(element) || /*#__PURE__*/ isValidElement(element)) {
                return /*#__PURE__*/ cloneElement(element, {
                    ...element.props,
                    status,
                    key: index
                });
            }
            return element;
        });
    }, [
        children,
        status
    ]);
    return jsxs("li", {
        "aria-current": status === 'current' ? 'step' : undefined,
        className: classNames('cb-status-tracker-step', className),
        ...rest,
        children: [
            jsxs("div", {
                className: "step-indicator-container",
                children: [
                    jsx("div", {
                        children: jsx(SkeletonBox, {
                            loading: loading,
                            children: jsx(Icon, {
                                className: iconStatus,
                                name: icons[iconStatus],
                                size: 24
                            })
                        })
                    }),
                    !isLastStep && jsx("div", {
                        className: "step-connector-wrapper",
                        children: jsx("div", {
                            className: classNames('step-connector', {
                                loading
                            }),
                            "data-testid": "step-connector"
                        })
                    })
                ]
            }),
            jsx("div", {
                className: classNames('step-content', {
                    loading
                }),
                children: updatedChildren
            })
        ]
    });
};
StatusTrackerStep.displayName = 'StatusTrackerStep';

export { StatusTrackerStep };
//# sourceMappingURL=StatusTrackerStep.es.js.map
